import { BrandIconSpinner, DocPreview, Button, Modal } from 'components';
import { PostBox } from 'pages/home/Home.style';
import React, { useEffect, useState } from 'react';
import Profile from 'assert/images/Common/profileImg.svg';
import { Divider } from '@mui/material';
import clsx from 'clsx';
import { Notification } from 'components/CustomNotification';
import { UpdateJobStatus } from 'redux/features/PostJobSlice';
import { useDispatch, useSelector } from 'react-redux';
import BasicChips from 'components/Chip';

import { ReactComponent as NoDataFound } from 'assert/images/Common/noDataFound.svg';
import PaginationComp from 'components/Pagination';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import useWindowDimensions from 'components/Dimention';
import { swipeModalWidth } from 'utils/helper';
import SwipeableEdgeDrawer from 'components/SwipeableDrawer';
import { JobApplyListStyle } from './JobActivity.style';

// const pageSize = 15;

export default function JobAppliedList({
  jobApplylist,
  loading,
  handleFetchData,
  tabKey,
  state,
  handleManageMsgOpen,
  showAlert,
  openDeleteModel,
  setShowAlert,
  setOpenDeleteModel,
}) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;
  const { getProfile } = useSelector((state) => state?.ProfileSlice);

  const [jobData, setJobData] = useState(null);
  const [page, setPage] = useState(0);
  const [statusId, setStatusId] = useState([]);
  const [loadingById, setLoadingById] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);

  const jobList = jobApplylist?.rows;

  useEffect(() => {
    if (!isSmallScreen && jobList && jobData === null) {
      setJobData(jobList?.[0]);
    }
  }, [jobList]);

  const handleUpdateStatus = (name, item) => {
    if (!state.rejected || !state.selected) {
      handleManageMsgOpen(true);
      Notification('info', 'Please save the Rejected & Selected message');
      return;
    }
    let status;
    switch (name) {
      case 'hold':
        status = 0;
        break;
      case 'select':
        status = 1;
        break;
      case 'reject':
        status = 2;
        break;
      default:
        break;
    }

    const data = {
      id: item?.id,
      status,
      userEmail:
        item?.data?.Email || item?.data?.Email0 || item?.userDetails?.userEmail,
    };
    const payload = {
      status: [data],
      message:
        status === 0
          ? state.held
          : status === 1
          ? state.selected
          : status === 2
          ? state.rejected
          : '',
      jobPostedByName: getProfile?.username,
    };
    setLoadingById([...loadingById, item?.id]);
    dispatch(UpdateJobStatus(payload))
      .then(() => {
        setLoadingById(loadingById.filter((listId) => listId !== item?.id));
        setStatusId([...statusId, data]);
      })
      .catch((err) => {
        setLoadingById(loadingById.filter((listId) => listId !== item?.id));
        Notification('warning', err?.message);
      });
  };

  const handleGetContent = () => {
    return (
      <JobApplyListStyle>
        <div className="apply-list-doc">
          <div className="apply-title">{t('profile.CandidateInfo')}</div>
          <table className="apply-label-value-container">
            <tbody>
              {Object.keys(jobData?.data)
                .filter((li) => li !== 'skill' && li !== 'experience')
                .map((li, index) => {
                  const match = li.match(/\d+$/);
                  const trailingNumber = match ? parseInt(match[0], 10) : null;
                  const formattedLi =
                    trailingNumber === index ? li.replace(/\d+$/, '') : li;

                  const value = jobData?.data?.[li];
                  const isDateLike =
                    typeof value === 'string' &&
                    /^\d{4}-\d{2}-\d{2}$/.test(value);
                  const formattedValue = isDateLike
                    ? moment(value).format('DD-MM-YYYY')
                    : value || '----';

                  return (
                    <tr key={index}>
                      <td>
                        {t(`profile.${formattedLi}`, {
                          defaultValue: formattedLi,
                        })}
                      </td>
                      <td>{formattedValue}</td>
                    </tr>
                  );
                })}
              <tr>
                <td>{t('profile.Skill')}</td>
                <td className="job-list-skill">
                  {jobData?.skill?.map((item, i) => (
                    <BasicChips size="small" key={i} label={item} />
                  ))}
                </td>
              </tr>
              <tr>
                <td>{t('profile.Experience')}</td>
                <td>{jobData?.experience + ' Yrs'}</td>
              </tr>
            </tbody>
          </table>
          {jobData?.resumePath && (
            <div className="job-attachment-container">
              <div className="apply-title-resume">
                {jobData.customFileNames?.[0]?.slice(0, -1) ||
                  t('profile.ResumeText')}
              </div>
              <DocPreview src={jobData.resumePath} readOnly />
            </div>
          )}
          {jobData?.coverLetterPath && (
            <div className="job-attachment-container">
              <div className="apply-title-resume">
                {jobData.customFileNames?.[1]?.slice(0, -1) ||
                  t('profile.CoverLetter')}
              </div>
              <DocPreview src={jobData.coverLetterPath} readOnly />
            </div>
          )}
          {jobData?.additionalFilePath && (
            <div className="job-attachment-container">
              <div className="apply-title-resume">
                {jobData.customFileNames?.[2]?.slice(0, -1) ||
                  'Additional Letter'}
              </div>
              <DocPreview src={jobData.additionalFilePath} readOnly />
            </div>
          )}
        </div>
      </JobApplyListStyle>
    );
  };

  return (
    <PostBox>
      <BrandIconSpinner loading={loading} />
      {jobList?.length === 0 ? (
        <div className="apply-list-notfound">
          <div className="no-data-found">
            <NoDataFound />
            <div>{t('profile.NoData')}</div>
          </div>
        </div>
      ) : (
        <div className="apply-list-container">
          <div>
            {jobList?.map((list, index) => {
              const data = list?.data;
              const btnStatus = statusId.find((item) => item?.id === list.id);
              const isStatusChanged =
                btnStatus?.status === 0 ||
                btnStatus?.status === 1 ||
                btnStatus?.status === 2;
              const isStatusZero = btnStatus?.status === 0;
              const isStatusOne = btnStatus?.status === 1;
              const isStatusTwo = btnStatus?.status === 2;

              return (
                <div key={index} className="apply-list-item">
                  <div
                    className={clsx(
                      'apply-list-item-container',
                      list?.id === jobData?.id && 'apply-list-bg'
                    )}
                  >
                    <div
                      className={'apply-list-item-content'}
                      onClick={() => {
                        setJobData(list);
                        setModalOpen(true);
                      }}
                    >
                      <img
                        src={list?.userDetails?.profileImage || Profile}
                        className="profile-img"
                        alt="profile-picture"
                      />
                      <div>
                        <div className="user-name">
                          @{list?.userDetails?.username}
                        </div>

                        {Object.keys(data).map((li, index) => {
                          if (index > 1) return null;
                          return (
                            <div key={index} className="apply-list-item-text">
                              {data[li]}
                            </div>
                          );
                        })}
                        <div className="apply-list-skills">
                          {list?.skill?.map(
                            (item, i) =>
                              `${item}${
                                list?.skill?.length === i + 1 ? '' : ', '
                              }`
                          )}
                        </div>
                        <div className="apply-list-experience">
                          Exp: {list?.experience} Yrs
                        </div>
                      </div>
                    </div>
                    <div className="apply-action">
                      {tabKey !== 1 && tabKey !== 2 && tabKey !== 3 && (
                        <Button
                          loading={loadingById.includes(list?.id)}
                          label={
                            isStatusZero
                              ? t('profile.Held')
                              : t('profile.OnHold')
                          }
                          variant={isStatusZero ? 'contained' : 'outlined'}
                          onClick={() =>
                            isStatusZero ? {} : handleUpdateStatus('hold', list)
                          }
                          disabled={isStatusChanged && !isStatusZero}
                          disableElevation={isStatusChanged}
                        />
                      )}
                      {tabKey !== 2 && tabKey !== 3 && (
                        <Button
                          loading={loadingById.includes(list?.id)}
                          label={
                            isStatusOne
                              ? t('profile.Selected')
                              : t('profile.Select')
                          }
                          variant={isStatusOne ? 'contained' : 'outlined'}
                          onClick={() =>
                            isStatusOne
                              ? {}
                              : showAlert
                              ? setOpenDeleteModel({ type: 'select', list })
                              : handleUpdateStatus('select', list)
                          }
                          color="success"
                          disabled={isStatusChanged && !isStatusOne}
                          disableElevation={isStatusChanged}
                        />
                      )}
                      {tabKey !== 3 && tabKey !== 2 && (
                        <Button
                          loading={loadingById.includes(list?.id)}
                          label={
                            isStatusTwo
                              ? t('profile.Rejected')
                              : t('profile.Reject')
                          }
                          variant={isStatusTwo ? 'contained' : 'outlined'}
                          onClick={() =>
                            isStatusTwo
                              ? {}
                              : showAlert
                              ? setOpenDeleteModel({ type: 'reject', list })
                              : handleUpdateStatus('reject', list)
                          }
                          color="error"
                          disabled={isStatusChanged && !isStatusTwo}
                          disableElevation={isStatusChanged}
                        />
                      )}
                    </div>
                  </div>
                </div>
              );
            })}
            <Modal
              removeHeader
              modalchanges="headerProfile"
              handleCancelModal={() => {
                setOpenDeleteModel(null);
                // setShowAlert(false);
              }}
              openModal={openDeleteModel !== null}
              content={
                <div className="confirmModal">
                  <div className="title">
                    {t('profile.OnceYouHave')} <b>{t('profile.selected')}</b>{' '}
                    {t('profile.or')} <b>{t('profile.rejected')}</b>
                    {t('profile.Undo')}
                  </div>
                  <Button
                    label={t('profile.Submit')}
                    variant="outlined"
                    onClick={() => {
                      handleUpdateStatus(
                        openDeleteModel?.type,
                        openDeleteModel?.list
                      );
                      setOpenDeleteModel(null);
                      setShowAlert(false);
                    }}
                  />
                  <Button
                    label={t('profile.Cancel')}
                    color="error"
                    variant="text"
                    onClick={() => {
                      setOpenDeleteModel(null);
                      // setShowAlert(false);
                    }}
                  />
                </div>
              }
            />
            <div>
              <Divider />
              <div className="pagination-container">
                <PaginationComp
                  size={'medium'}
                  totalPageSize={jobApplylist?.hasMore ? page + 2 : page + 1}
                  page={page + 1}
                  isDisplayDot={jobApplylist?.hasMore}
                  handleChange={(value) => {
                    handleFetchData();
                    setPage(value - 1);
                  }}
                />
              </div>
            </div>
          </div>
          {!isSmallScreen && <Divider orientation="vertical" flexItem />}
          {isSmallScreen ? (
            <SwipeableEdgeDrawer
              openDrawer={modalOpen}
              handleCloseDrawer={() => {
                setModalOpen(false);
              }}
            >
              {modalOpen && jobData && handleGetContent()}
            </SwipeableEdgeDrawer>
          ) : (
            <div>{jobData && handleGetContent()}</div>
          )}
        </div>
      )}
    </PostBox>
  );
}
